import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "./../custom.css";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import {
  getFinancialYearList,
  getFinancialYearListNew,
} from "../../../core/common/financialYear";

const PmsR2Manager = () => {
  const params = useParams();

  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);

  const [managerRatingData, setManagerRatingData] = useState<any>({});
  const [sameAsKraChecked, setSameAsKraChecked] = useState(false);
  const [sameAsPotentialChecked, setSameAsPotentialChecked] = useState(false);

  const [countKra, setCountKra] = useState(1);
  const [countPotensial, setCountPotensial] = useState(1);
  const [countOverAll, setCountOverAll] = useState(1);
  const [activetab, setActivetab] = useState<any>("kra");
  const [kraDetailsData, setKraDetailsData] = useState<any>([]);
  const [behaDetailsData, setBehaDetailsData] = useState<any>([]);
  const [potentialData, setPotentialData] = useState<any>([]);
  const [ratingData, setRatingData] = useState<any>([]);
  const [comaspiDetailsData, setComaspiDetailsData] = useState<any>({});
  const [selectedRecs, setSelectedRecs] = useState<any>({});
  const routes = all_routes;

  const [marketAdjustment, setMarketAdjustment] = useState<any>(0);

  const [recommendationData, setRecommendationData] = useState<any>({
    type_id: null,
    justification: "",
    from_location_id: "",
    to_location_id: "",
    from_designation_id: "",
    to_designation_id: "",
    increment_percent: "",
    training_type: "",
    market_adjustment: null,
    re_designation: "",
  });

  const ratingOptions = [
    { value: "OS", label: "Outstanding (OS)" },
    { value: "VG", label: "Very Good (VG)" },
    { value: "G", label: "Good (G)" },
    { value: "AVG", label: "Average (Avg)" },
    { value: "P", label: "Poor (P)" },
  ];
  const ratingBehaiviroul = [
    { value: "P", label: "L1" },
    { value: "AVG", label: "L2" },
    { value: "G", label: "L3" },
    { value: "VG", label: "L4" },
    // { value: "OS", label: "L5" },
  ];

  const tabs = [
    { value: "kra", label: "KRA 80%" },
    { value: "Potential", label: "Potential 20%" },
    { value: "Overall Comments", label: "Overall Comments" },
  ];
  const {
    data: getappraisalTiming,
    loading: appraisalTimingLoading,
    error: appraisalTimingError,
  } = useApi("/api/get-apparisal-timing-skipmanager", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });
  const {
    data: getkradetails,
    loading: kradetailsLoading,
    error: kradetailsError,
  } = useApi("/api/get-kra-appraisal-r2", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year, countKra],
  });

  const {
    data: getPotentialdetails,
    loading: PotentialdetailsLoading,
    error: PotentialdetailsError,
  } = useApi("/api/get-r2-potensial-appraisal", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year, countPotensial],
  });
  const {
    data: getRatingdetails,
    loading: RatingdetailsLoading,
    error: RatingdetailsError,
  } = useApi("/api/get-rating", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getcomaspidetails,
    loading: comaspidetailsLoading,
    error: comaspidetailsError,
  } = useApi("/api/get-overall-comments-r2", {
    method: "POST",
    payload: {
      employee_id: params?.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year, countOverAll],
  });

  const {
    data: getPMSStatusManager,
    loading: PMSStatusManagerLoading,
    error: PMSStatusManagerError,
  } = useApi("/api/get-R2-pms-status", {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year, countOverAll],
  });

  const {
    data: getPMStotalRating,
    loading: PMStotalRatingLoading,
    error: PMStotalRatingError,
  } = useApi("/api/get-r2-pms-rating", {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year, countKra, countPotensial],
  });

  // const {
  //   data: getPMSStatus,
  //   loading: PMSStatusLoading,
  //   error: PMSStatusError,
  // } = useApi("/api/get-employee-response-R2", {
  //   method: "POST",
  //   payload: {
  //     employee_id: params.employee_id,
  //     financial_year: finance_year,
  //   },
  //   autoCall: true,
  // });

  const {
    data: getRecommendationType,
    loading: RecommendationTypeLoading,
    error: RecommendationTypeError,
  } = useApi("/api/get-recommendation-type", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getworkLocatation,
    loading: workLocatationLoading,
    error: workLocatationError,
  } = useApi("/api/get-workLocatation", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: profileResponse,
    error: profileResponseError,
    loading: profileResponseLoading,
  } = useApi(`/api/get-employee-details/${params.employee_id}`, {
    method: "GET",
    autoCall: true,
  });

  const {
    data: upperDesignations,
    error: upperDesignationsError,
    loading: upperDesignationsLoading,
  } = useApi(`/api/get-employee-upper-designations/${params.employee_id}`, {
    method: "GET",
    autoCall: true,
  });

  const {
    data: reDesignations,
    error: reDesignationsError,
    loading: reDesignationsLoading,
  } = useApi(`/api/get-employee-re-designations/${params.employee_id}`, {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getRecomandations,
    error: getRecomandationsError,
    loading: getRecomandationsLoading,
  } = useApi(`/api/get-Recomandations-employee-r2`, {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    dependencies: [finance_year, params.employee_id],
    autoCall: true,
  });

  const {
    data: getstatus,
    loading: statusLoading,
    error: statusError,
  } = useApi("/api/get-pms-status", {
    method: "POST",
    payload: {
      employee_id: params.employee_id,
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year, countKra, countPotensial, countOverAll],
  });

  useEffect(() => {
    if (getPMStotalRating?.success)
      setManagerRatingData(getPMStotalRating?.data);
  }, [getPMStotalRating]);

  useEffect(() => {
    if (getkradetails?.success) setKraDetailsData(getkradetails?.data);
  }, [getkradetails]);

  useEffect(() => {
    if (getcomaspidetails?.success) {
      setComaspiDetailsData(getcomaspidetails?.data);
    }
  }, [getcomaspidetails]);

  useEffect(() => {
    if (getPotentialdetails?.success) {
      setPotentialData(getPotentialdetails?.data);
    }
  }, [getPotentialdetails]);

  useEffect(() => {
    if (getRatingdetails?.success) {
      setRatingData(getRatingdetails?.data);
    }
  }, [getRatingdetails]);

  // useEffect(() => {
  //   if (getRecomandations?.success) {
  //     const data = getRecomandations.data;
  //     setMarketAdjustment(
  //       data?.market_adjustment !== null &&
  //         data?.market_adjustment !== undefined
  //         ? String(data.market_adjustment)
  //         : "",
  //     );
  //     setRecommendationData((prev: any) => ({
  //       ...prev,
  //       ...data,
  //       from_location_id: profileResponse?.data[0].work_location_id,
  //       from_designation_id: profileResponse?.data[0].designation_id,
  //     }));
  //   }
  // }, [getRecomandations, finance_year]);

  useEffect(() => {
    if (getRecomandations?.success && getRecomandations?.data) {
      const mapped: any = {};

      getRecomandations.data.forEach((rec: any) => {
        mapped[rec.type_id] = {
          selected: true,
          justification: rec.justification || "",
          to_designation: rec.to_designation_id || "",
          to_branch: rec.to_location_id || "",
          adjustment: rec.market_adjustment || "",
          training_type: rec.training_type || "",
        };
      });

      setSelectedRecs(mapped);
    }
  }, [getRecomandations, finance_year]);

  console.log(marketAdjustment, "market_adjustment");

  const handleKraChange = (index: number, field: string, value: any) => {
    const updatedData = [...kraDetailsData];
    updatedData[index][field] = value;
    setKraDetailsData(updatedData);
  };

  const handlePotensialChange = (
    categoryIndex: number,
    subcategoryIndex: number,
    field: string,
    value: any,
  ) => {
    const updated = [...potentialData];

    updated[categoryIndex].subcategories[subcategoryIndex][field] = value;

    setPotentialData(updated);
  };

  const getInputdata = (e: any) => {
    console.log(comaspiDetailsData);
    const { name, value } = e.target;
    setComaspiDetailsData({ ...comaspiDetailsData, [name]: value });
  };

  const {
    data: addkraRatingdetails,
    loading: addkraRatingdetailsLoading,
    error: addkraRatingdetailsError,
    callApi: AddRaitingKra,
  } = useApi("/api/add-kra-appraisal-r2", {
    method: "POST",
    autoCall: false,
  });

  const KRASaveDraft = async (e: any) => {
    e.preventDefault();
    const filterData = kraDetailsData.filter(
      (item: any, index: any) => item.rating && item.achievement !== null,
    );

    const ratingData = filterData.map((item: any, index: any) => {
      return {
        rating: item.rating,
        achievement: item.achievement,
        kra_id: item.kra_id,
      };
    });
    const payload = {
      employee_id: params?.employee_id,
      role: "R2",
      financial_year: finance_year,
      appraisal_data: ratingData,
    };
    try {
      const response = await AddRaitingKra(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setActivetab("Potential");
        });
      }
      setCountKra(countKra + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addBehaRatingdetails,
    loading: addBehaRatingdetailsLoading,
    error: addBehaRatingdetailsError,
    callApi: AddRaitingBeha,
  } = useApi("/api/manager/add-behavioural-comments", {
    method: "POST",
    autoCall: false,
  });

  const BhaviorSaveDraft = async (e: any, status: any) => {
    e.preventDefault();
    const filterData = behaDetailsData.filter(
      (item: any, index: any) =>
        item.manager_rating && item.manager_comments !== null,
    );
    const goal_id =
      behaDetailsData && behaDetailsData.length > 0
        ? behaDetailsData[0].goal_id
        : null;

    const ratingData = filterData.map((item: any, index: any) => {
      return {
        manager_rating: item.manager_rating,
        manager_comments: item.manager_comments,
        behavioural_id: item.behavioural_id,
      };
    });
    const payload = {
      status: status,
      employee_id: params?.employee_id,
      goal_id: goal_id,
      rating_data: ratingData,
    };
    try {
      const response = await AddRaitingBeha(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addPotensialRatingdetails,
    loading: addPotensialRatingdetailsLoading,
    error: addPotensialRatingdetailsError,
    callApi: AddRaitingPotensial,
  } = useApi("/api/add-r2-potensial-appraisal", {
    method: "POST",
    autoCall: false,
  });

  const PotensialSaveDraft = async (e: any) => {
    e.preventDefault();
    const apprisal_data: any[] = [];

    potentialData.forEach((category: any) => {
      category.subcategories.forEach((sub: any) => {
        if (sub.rating && sub.achievement !== null) {
          apprisal_data.push({
            subcategory_id: sub.id,
            rating: sub.rating,
            achievement: sub.achievement,
          });
        }
      });
    });

    const payload = {
      financial_year: finance_year,
      role: "R2",
      employee_id: params.employee_id,
      apprisal_data: apprisal_data,
    };
    try {
      const response = await AddRaitingPotensial(payload);

      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setActivetab("Overall Comments");
        });
      }
      setCountPotensial(countPotensial + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const validateRecommendations = () => {
    const errors: string[] = [];

    // Promotion
    if (selectedRecs[1]?.selected) {
      if (!selectedRecs[1]?.to_designation) {
        errors.push("Promotion recommendation is required");
      }

      if (!selectedRecs[1]?.justification?.trim()) {
        errors.push("Promotion justification is required");
      }
    }

    // Transfer
    if (selectedRecs[3]?.selected) {
      if (!selectedRecs[3]?.to_branch) {
        errors.push("Transfer location is required");
      }

      if (!selectedRecs[3]?.justification?.trim()) {
        errors.push("Transfer justification is required");
      }
    }

    // Market Adjustment
    if (selectedRecs[8]?.selected) {
      if (
        selectedRecs[8]?.adjustment === "" ||
        selectedRecs[8]?.adjustment === undefined
      ) {
        errors.push("Market adjustment percentage is required");
      }

      if (!selectedRecs[8]?.justification?.trim()) {
        errors.push("Market adjustment justification is required");
      }
    }

    // Re-designation
    if (selectedRecs[9]?.selected) {
      if (!selectedRecs[9]?.to_designation) {
        errors.push("Re-designation is required");
      }

      if (!selectedRecs[9]?.justification?.trim()) {
        errors.push("Re-designation justification is required");
      }
    }

    // Training
    if (selectedRecs[10]?.selected) {
      if (!selectedRecs[10]?.training_type) {
        errors.push("Training type is required");
      }

      if (!selectedRecs[10]?.justification?.trim()) {
        errors.push("Training justification is required");
      }
    }

    // None Of Above
    if (selectedRecs[14]?.selected) {
      if (!selectedRecs[14]?.justification?.trim()) {
        errors.push("Justification is required");
      }
    }

    return errors;
  };

  const {
    data: addCompAspRatingdetails,
    loading: addCompAspRatingdetailsLoading,
    error: addCompAspRatingdetailsError,
    callApi: AddRaitingCompAsp,
  } = useApi("/api/add-overall-comments-r2", {
    method: "POST",
    autoCall: false,
  });

  const handleCheckboxChange = (typeId: number, checked: boolean) => {
    setSelectedRecs((prev: any) => ({
      ...prev,
      [typeId]: {
        ...prev[typeId],
        selected: checked,
      },
    }));
  };

  const handleRecChange = (typeId: number, field: string, value: any) => {
    setSelectedRecs((prev: any) => ({
      ...prev,
      [typeId]: {
        ...prev[typeId],
        [field]: value,
      },
    }));
  };

  const buildRecommendationPayload = () => {
    return Object.keys(selectedRecs)
      .filter((key) => selectedRecs[key].selected)
      .map((key) => {
        const rec = selectedRecs[key];

        return {
          type_id: Number(key),
          to_designation: rec.to_designation || null,
          to_branch: rec.to_branch || null,
          adjustment: rec.adjustment || null,
          justification: rec.justification || "",
          training_type: rec.training_type || null,
        };
      });
  };

  const ComAspSaveData = async (e: any, status: string) => {
    e.preventDefault();
    const validationError = validateRecommendations();
    if (validationError.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: validationError[0],
        confirmButtonText: "OK",
      });

      return;
    }

    const recommendations = buildRecommendationPayload();
    const payload = {
      employee_id: params.employee_id,
      financial_year: finance_year,
      role: "R2",
      status,
      carrier_aspiration_comments:
        comaspiDetailsData.skip_manager_carrier_aspiration,
      carrier_aspiration: comaspiDetailsData.ID,
      comments: comaspiDetailsData.comments,
      recommendations,
    };

    // console.log(payload);

    const isDraft = status === "Draft";

    const result = await Swal.fire({
      title: isDraft ? "Save as Draft?" : "Submit Review?",
      text: isDraft
        ? "Your progress will be saved as a draft. You can continue and make changes later."
        : "Once you submit the performance review, you won't be able to make any changes.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: isDraft ? "Yes, Save Draft" : "Yes, Submit",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }
    try {
      const response = await AddRaitingCompAsp(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
      setCountOverAll(countOverAll + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const sameAs = (e: any) => {
    const isChecked = e.target.checked;
    if (activetab === "kra") {
      if (isChecked) {
        const updated = kraDetailsData.map((item: any) => ({
          ...item,
          rating: item.r1_rating,
          achievement: item.r1_achievement,
        }));

        setKraDetailsData(updated);
      } else {
        const updated = kraDetailsData.map((item: any) => ({
          ...item,
          rating: item.rating,
          achievement: item.achievement,
        }));

        setKraDetailsData(updated);
      }
    } else if (activetab === "Potential") {
      if (isChecked) {
        const updated = potentialData.map((cat: any) => ({
          ...cat,
          subcategories: cat.subcategories.map((sub: any) => ({
            ...sub,
            rating: sub.r1_rating,
            achievement: sub.r1_achievement,
          })),
        }));
        setPotentialData(updated);
      } else {
        const updated = potentialData.map((cat: any) => ({
          ...cat,
          subcategories: cat.subcategories.map((sub: any) => ({
            ...sub,
            rating: sub.rating,
            achievement: sub.achievement,
          })),
        }));
        setPotentialData(updated);
      }
    }
  };

  const increaseMarket = () => {
    setSelectedRecs((prev: any) => {
      let current = Number(prev[8]?.adjustment || 0);

      let next = current + 0.01;

      if (next > 100) next = 100;

      return {
        ...prev,
        8: {
          ...prev[8],
          adjustment: Number(next.toFixed(2)),
        },
      };
    });
  };

  const decreaseMarket = () => {
    setSelectedRecs((prev: any) => {
      let current = Number(prev[8]?.adjustment || 0);

      let next = current - 0.01;

      if (next < 0) next = 0;

      return {
        ...prev,
        8: {
          ...prev[8],
          adjustment: Number(next.toFixed(2)),
        },
      };
    });
  };

  useEffect(() => {
    setSameAsKraChecked(false);
    setSameAsPotentialChecked(false);
  }, [activetab]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">
                Performance Review {params.employee_name} ({params.employee_id})
              </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">PMS</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Performance Review Skip Manager
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearListNew(finance_year).map((fy) => (
                    <option key={fy} value={fy}>
                      {fy}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-2">
                  <div>
                    <button className="btn btn-outline-secondary">
                      Save as draft
                    </button>
                  </div>
                  <div>
                    <button className="btn btn-outline-secondary">Submit</button>
                  </div>
                </div>
                <div className="d-flex gap-2">
                  <div>
                    <button className="btn btn-outline-secondary">
                      Save as draft
                    </button>
                  </div>
                  <div>
                    <button
                      className="btn btn-outline-secondary"
                      data-bs-toggle="modal"
                      data-bs-target={activetab === "Behavioural Competence" ? "#behaviouralinfo" : "#ratinginfo" }
                    >
                      <i className="fa fa-users"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <section className="custom-card">
            <div className="custom-card-header d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                {tabs.map((item, index) => (
                  <button
                    className={`${
                      activetab === item.value
                        ? "btn btn-primary custom_button"
                        : "btn btn-primary tab-button"
                    }`}
                    onClick={() => {
                      setActivetab(item.value);
                    }}
                    // style={{ border: "2px solid red" }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-3">
                {(activetab === "kra" || activetab === "Potential") && (
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="sameAsManager"
                      checked={
                        activetab === "kra"
                          ? sameAsKraChecked
                          : sameAsPotentialChecked
                      }
                      onChange={(e) => {
                        const checked = e.target.checked;

                        if (activetab === "kra") {
                          setSameAsKraChecked(checked);
                        } else {
                          setSameAsPotentialChecked(checked);
                        }

                        sameAs(e);
                      }}
                      disabled={getPMSStatusManager?.data?.status === "Submit"}
                    />
                    <label className="form-check-label" htmlFor="sameAsManager">
                      Same As Manager
                    </label>
                  </div>
                )}

                <div className="d-flex gap-3">
                  <div>
                    <span
                      className={`badge `}
                      style={{ backgroundColor: "#2e3294" }}
                    >
                      Status : {getstatus?.status}
                    </span>
                  </div>
                  <button
                    className="btn btn-outline-secondary"
                    data-bs-toggle="modal"
                    data-bs-target={
                      activetab === "Behavioural Competence"
                        ? "#behaviouralinfo"
                        : "#ratinginfo"
                    }
                  >
                    <i className="fa fa-users"></i>
                  </button>
                </div>
              </div>
            </div>

            {activetab === "kra" ? (
              <>
                {kraDetailsData && kraDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            {/* <th>Category</th> */}
                            <th>Smart Goal</th>
                            <th>Target</th>
                            <th>Date</th>
                            <th>File</th>
                            <th>Wt(%)</th>
                            <th>Unit</th>
                            <th>Employee Rating</th>
                            <th>Employee Comments</th>
                            <th>Manager Rating</th>
                            <th>Manager Comments</th>
                            <th>Skip Manager Rating</th>
                            <th>Skip Manager Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {kraDetailsData &&
                            kraDetailsData.map((item: any, idx: any) => {
                              return (
                                <tr key={item.id}>
                                  <td className="allcolor">{idx + 1}</td>
                                  {/* <td className="allcolor">
                                    <p>{item.kra_category_name}</p>
                                  </td>
                                  <td className="allcolor">
                                    <p>{item?.smart_goals}</p>
                                  </td> */}
                                  <td className="allcolor">
                                    <p>
                                      <strong>{item.smart_goals}</strong>
                                    </p>
                                    <p>{item.kra_category_name}</p>
                                  </td>
                                  <td className="allcolor">
                                    <ul>
                                      {(() => {
                                        let targets = [];
                                        try {
                                          targets = JSON.parse(item.target);
                                          if (!Array.isArray(targets))
                                            targets = [];
                                        } catch (e) {
                                          console.error(
                                            "Invalid JSON:",
                                            item.target,
                                          );
                                        }

                                        return targets.map(
                                          (targetItem: any, index: any) => (
                                            <li key={index}>
                                              {index + 1}. {targetItem}
                                            </li>
                                          ),
                                        );
                                      })()}
                                    </ul>
                                  </td>

                                  <td className="allcolor">
                                    {item.target_achievement_date}
                                  </td>
                                  <td className="allcolor">
                                    {!item.attachment_url ||
                                    item.attachment_url.endsWith("/null") ? (
                                      "N/A"
                                    ) : (
                                      <a
                                        href={item.attachment_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "blue",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        View
                                      </a>
                                    )}
                                  </td>

                                  <td className="allcolor">{item.weightage}</td>
                                  <td className="allcolor">
                                    <p>{item.unit}</p>
                                  </td>
                                  {/* <td className="allcolor">
                                    <select
                                      className="form-select"
                                      value={item?.employee_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolor">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item.employee_achievement}
                                      readOnly
                                    />
                                  </td> */}
                                  <td className="allcoloremployee">
                                    <select
                                      className="form-select allcoloremployee"
                                      value={item?.employee_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map((option, index) => (
                                        <option
                                          key={index}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </td>

                                  <td className="allcoloremployee">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcoloremployee"
                                      value={item.employee_achievement}
                                      readOnly
                                    />
                                  </td>

                                  <td className="allcolormanager">
                                    <select
                                      className="form-select "
                                      value={item?.r1_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolormanager">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcolormanager"
                                      value={item?.r1_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <select
                                      className="form-select"
                                      value={item?.rating || ""}
                                      disabled={
                                        getPMSStatusManager?.data?.status ===
                                        "Submit"
                                      }
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "rating",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingOptions.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td>
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item?.achievement}
                                      readOnly={
                                        getPMSStatusManager?.data?.status ===
                                        "Submit"
                                      }
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "achievement",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {(() => {
                      const endDate =
                        getappraisalTiming?.data?.r2_manager_end_date;
                      const cycleStatus =
                        getappraisalTiming?.data?.apprisal_cycle_status;
                      const today = new Date();

                      const isExpired =
                        endDate &&
                        new Date(endDate) <
                          new Date(today.toISOString().split("T")[0]);

                      const isCycleClosedOrSuspended =
                        cycleStatus === "closed" || cycleStatus === "suspended";

                      // If expired OR cycle closed/suspended → show message
                      if (isExpired || isCycleClosedOrSuspended) {
                        return (
                          <div className="alert alert-danger text-center m-2">
                            The appraisal cycle is closed or the submission date
                            has expired. Please contact the HR team.
                          </div>
                        );
                      }

                      // If already submitted → hide button
                      if (getPMSStatusManager?.data?.status === "Submit") {
                        return null;
                      }

                      // Otherwise show button
                      return (
                        <div className="p-2 d-flex gap-2 justify-content-end">
                          <div>
                            <button
                              className="btn btn-primary tab-button"
                              onClick={(e: any) => {
                                KRASaveDraft(e);
                              }}
                            >
                              Save & Next
                            </button>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : activetab === "Behavioural Competence" ? (
              <>
                {behaDetailsData && behaDetailsData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Behavioural Competency</th>
                            <th>Description</th>
                            {/* <th>Weightage(%)</th> */}
                            <th>Employee Rating</th>
                            <th>Employee Comments</th>
                            <th>Manager Rating</th>
                            <th>Manager Comments</th>
                            <th>Skip Manager Rating</th>
                            <th>Skip Manager Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {behaDetailsData &&
                            behaDetailsData.map((item: any, idx: any) => {
                              return (
                                <tr key={item.id}>
                                  <td className="allcolor">{idx + 1}</td>

                                  <td className="allcolor">
                                    <p>{item?.competency_name}</p>
                                  </td>
                                  <td className="allcolor">
                                    <ul>
                                      {item.description?.map(
                                        (targetItem: string, index: number) => (
                                          <li key={index}>
                                            <input
                                              type="radio"
                                              name={`option-${item.id}`}
                                              id={`option-${item.id}-${index}`}
                                            />{" "}
                                            &nbsp;
                                            <label
                                              htmlFor={`option-${item.id}-${index}`}
                                            >
                                              {targetItem}
                                            </label>
                                          </li>
                                        ),
                                      )}
                                    </ul>
                                  </td>

                                  {/* <td>{item.weightage}</td> */}
                                  <td className="allcoloremployee">
                                    <select
                                      className="form-select"
                                      value={item.self_rating || ""}
                                      disabled
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingBehaiviroul.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcoloremployee">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea allcoloremployee"
                                      value={item.self_achievement}
                                      readOnly
                                    />
                                  </td>
                                  <td className="allcolor">
                                    <select
                                      className="form-select"
                                      value={item?.manager_rating || ""}
                                      disabled={item.status === "M_APPROVED"}
                                      onChange={(e: any) => {
                                        handleKraChange(
                                          idx,
                                          "manager_rating",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingBehaiviroul.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td className="allcolor">
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item?.manager_comments}
                                      readOnly={item.status === "M_APPROVED"}
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "manager_comments",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </td>

                                  <td>
                                    <select
                                      className="form-select"
                                      value={item?.manager_rating || ""}
                                      disabled={item.status === "M_APPROVED"}
                                      onChange={(e: any) => {
                                        handleKraChange(
                                          idx,
                                          "manager_rating",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select Rating</option>
                                      {ratingBehaiviroul.map(
                                        (option: any, index: any) => (
                                          <option
                                            key={index}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </td>
                                  <td>
                                    <textarea
                                      rows={2}
                                      className="custom-textarea"
                                      value={item?.manager_comments}
                                      readOnly={item.status === "M_APPROVED"}
                                      onChange={(e) => {
                                        handleKraChange(
                                          idx,
                                          "manager_comments",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {behaDetailsData &&
                    behaDetailsData.length > 0 &&
                    behaDetailsData[0].status === "M_APPROVED" ? (
                      <div className="p-2 d-flex gap-2 justify-content-end">
                        <p className="text-danger fw-bold">
                          You have successfully submitted your Performance.
                          Please note that you will not be able to make any
                          further changes.
                        </p>
                      </div>
                    ) : (
                      <div>
                        {(() => {
                          const endDate =
                            getappraisalTiming?.data?.r2_manager_end_date;
                          const cycleStatus =
                            getappraisalTiming?.data?.apprisal_cycle_status;
                          const today = new Date();

                          const isExpired =
                            endDate &&
                            new Date(endDate) <
                              new Date(today.toISOString().split("T")[0]);

                          const isCycleClosedOrSuspended =
                            cycleStatus === "closed" ||
                            cycleStatus === "suspended";

                          // If expired OR cycle closed/suspended → show message
                          if (isExpired || isCycleClosedOrSuspended) {
                            return (
                              <div className="alert alert-danger text-center m-2">
                                The appraisal cycle is closed or the submission
                                date has expired. Please contact the HR team.
                              </div>
                            );
                          }
                          if (getPMSStatusManager?.data?.status === "Submit") {
                            return null;
                          }

                          // Otherwise show button
                          return (
                            <div className="p-2 d-flex gap-2 justify-content-end">
                              <div>
                                <button
                                  className="btn btn-primary tab-button"
                                  onClick={(e: any) => {
                                    BhaviorSaveDraft(e, "M_DRAFT");
                                  }}
                                >
                                  Save & Next
                                </button>
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : activetab === "Potential" ? (
              <>
                {potentialData && potentialData.length > 0 ? (
                  <div className="custom-table-wrapper">
                    <div className="custom-table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Potential</th>
                            <th>Description</th>
                            <th>Employee Rating</th>
                            <th>Employee Comments</th>
                            <th>Manager Rating</th>
                            <th>Manager Comments</th>
                            <th>Skip Manager Rating</th>
                            <th>Skip Manager Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {potentialData.map((item: any, catIdx: number) =>
                            item.subcategories.map(
                              (subItem: any, subIdx: number) => {
                                const showSNo = subIdx === 0;
                                const showCategory = subIdx === 0;
                                const rowSpanCount = item.subcategories.length;

                                return (
                                  <tr key={`row-${catIdx}-${subIdx}`}>
                                    {showSNo ? (
                                      <td
                                        rowSpan={rowSpanCount}
                                        className="allcolor"
                                      >
                                        {catIdx + 1}
                                      </td>
                                    ) : null}
                                    {showCategory ? (
                                      <td
                                        rowSpan={rowSpanCount}
                                        className="allcolor"
                                      >
                                        {item.category}
                                      </td>
                                    ) : null}
                                    <td className="allcolor">
                                      {subItem.subcategory}
                                    </td>
                                    <td className="allcoloremployee">
                                      <select
                                        className="form-select"
                                        value={subItem.employee_rating || ""}
                                        disabled
                                      >
                                        <option value="">Select Rating</option>
                                        {ratingOptions.map(
                                          (option: any, index: any) => (
                                            <option
                                              key={index}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </td>
                                    <td className="allcoloremployee">
                                      <textarea
                                        rows={2}
                                        className="custom-textarea allcoloremployee"
                                        value={subItem.employee_achievement}
                                        readOnly
                                      />
                                    </td>
                                    <td className="allcolormanager">
                                      <select
                                        className="form-select"
                                        value={subItem?.r1_rating || ""}
                                        disabled
                                      >
                                        <option value="">Select Rating</option>
                                        {ratingOptions.map(
                                          (option: any, index: any) => (
                                            <option
                                              key={index}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </td>
                                    <td className="allcolormanager">
                                      <textarea
                                        rows={2}
                                        className="custom-textarea allcolormanager"
                                        value={subItem?.r1_achievement}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      <select
                                        className="form-select"
                                        value={subItem?.rating || ""}
                                        disabled={
                                          getPMSStatusManager?.data?.status ===
                                          "Submit"
                                        }
                                        onChange={(e: any) => {
                                          handlePotensialChange(
                                            catIdx,
                                            subIdx,
                                            "rating",
                                            e.target.value,
                                          );
                                        }}
                                      >
                                        <option value="">Select Rating</option>
                                        {ratingOptions.map(
                                          (option: any, index: any) => (
                                            <option
                                              key={index}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </option>
                                          ),
                                        )}
                                      </select>
                                    </td>
                                    <td>
                                      <textarea
                                        rows={2}
                                        className="custom-textarea"
                                        value={subItem?.achievement}
                                        readOnly={
                                          getPMSStatusManager?.data?.status ===
                                          "Submit"
                                        }
                                        onChange={(e) => {
                                          handlePotensialChange(
                                            catIdx,
                                            subIdx,
                                            "achievement",
                                            e.target.value,
                                          );
                                        }}
                                      />
                                    </td>{" "}
                                  </tr>
                                );
                              },
                            ),
                          )}
                        </tbody>
                      </table>
                    </div>
                    {(() => {
                      const endDate =
                        getappraisalTiming?.data?.r2_manager_end_date;
                      const cycleStatus =
                        getappraisalTiming?.data?.apprisal_cycle_status;
                      const today = new Date();

                      const isExpired =
                        endDate &&
                        new Date(endDate) <
                          new Date(today.toISOString().split("T")[0]);

                      const isCycleClosedOrSuspended =
                        cycleStatus === "closed" || cycleStatus === "suspended";

                      // If expired OR cycle closed/suspended → show message
                      if (isExpired || isCycleClosedOrSuspended) {
                        return (
                          <div className="alert alert-danger text-center m-2">
                            The appraisal cycle is closed or the submission date
                            has expired. Please contact the HR team.
                          </div>
                        );
                      }
                      if (getPMSStatusManager?.data?.status === "Submit") {
                        return null;
                      }

                      // Otherwise show button
                      return (
                        <div className="p-2 d-flex gap-2 justify-content-end">
                          <div>
                            <button
                              className="btn btn-primary tab-button"
                              onClick={(e: any) => {
                                PotensialSaveDraft(e);
                              }}
                            >
                              Save & Next
                            </button>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            ) : (
              <>
                {(kraDetailsData && kraDetailsData.length > 0) ||
                (potentialData && potentialData.length > 0) ? (
                  <>
                    <table className="overall-table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>KRA Rating</th>
                          <th>Potential Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Skip Manager Manager</td>
                          <td>
                            {managerRatingData?.KRA.skip_managerRating.toFixed(
                              2,
                            )}
                          </td>
                          <td>
                            {managerRatingData?.Potential.skip_managerRating.toFixed(
                              2,
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Manager</td>
                          <td>
                            {managerRatingData?.KRA.managerRating.toFixed(2)}
                          </td>
                          <td>
                            {managerRatingData?.Potential.managerRating.toFixed(
                              2,
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Employee</td>
                          <td>
                            {managerRatingData?.KRA.selfRating.toFixed(2)}
                          </td>
                          <td>
                            {managerRatingData?.Potential.selfRating.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="row p-2 mt-2">
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-semibold mb-1">
                          Employee Career Aspirations
                        </h5>
                        <textarea
                          className="form-control"
                          rows={5}
                          placeholder="Enter manager's comments here..."
                          value={
                            comaspiDetailsData?.employee_carrier_aspiration
                          }
                          readOnly
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-semibold mb-1">
                          Employee Overall Comments
                        </h5>
                        <textarea
                          className="form-control"
                          rows={5}
                          placeholder="Enter employee's comments here..."
                          readOnly
                          value={comaspiDetailsData?.employee_comments}
                        />
                      </div>
                    </div>
                    <div className="row p-2">
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-semibold mb-1">
                          Manager Career Aspirations
                        </h5>
                        <textarea
                          className="form-control"
                          rows={5}
                          placeholder="Enter manager's comments here..."
                          value={comaspiDetailsData?.manager_carrier_aspiration}
                          readOnly
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-semibold mb-1">
                          Manager Overall Comments
                        </h5>
                        <textarea
                          className="form-control"
                          rows={5}
                          placeholder="Enter employee's comments here..."
                          readOnly
                          value={comaspiDetailsData?.R1_comments}
                        />
                      </div>
                    </div>
                    <div className="row p-2">
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-semibold mb-1">
                          Skip Manager Career Aspirations
                        </h5>
                        <textarea
                          className="form-control"
                          rows={5}
                          placeholder="Enter career aspirations here..."
                          name="skip_manager_carrier_aspiration"
                          onChange={getInputdata}
                          value={
                            comaspiDetailsData?.skip_manager_carrier_aspiration
                          }
                          readOnly={
                            getPMSStatusManager?.data?.status === "Submit"
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-semibold mb-1">
                          Skip Manager Overall Comments
                        </h5>
                        <textarea
                          className="form-control"
                          rows={5}
                          placeholder="Enter comments here..."
                          name="comments"
                          onChange={getInputdata}
                          value={comaspiDetailsData?.comments}
                          readOnly={
                            getPMSStatusManager?.data?.status === "Submit"
                          }
                        />
                      </div>
                    </div>

                    <div className="p-3 mt-3">
                      <h4 className="fw-semibold mb-3">Recommendation</h4>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Select</th>
                            <th>Recommendation</th>
                            <th>From</th>
                            <th>To / Sub Recommendation</th>
                            <th>Justification</th>
                          </tr>
                        </thead>

                        <tbody>
                          {/* PROMOTION (1) */}
                          {(() => {
                            const item = getRecommendationType?.data.find(
                              (x: any) => x.type_id === 1,
                            );
                            if (!item) return null;

                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedRecs[1]?.selected || false}
                                    onChange={(e) =>
                                      handleCheckboxChange(1, e.target.checked)
                                    }
                                  />
                                </td>

                                <td>{item.type_name}</td>

                                <td>
                                  <input
                                    type="text"
                                    value={profileResponse?.data[0].designation}
                                    className="form-control"
                                    readOnly
                                  />
                                </td>

                                <td>
                                  <select
                                    className="form-select"
                                    disabled={!selectedRecs[1]?.selected}
                                    value={
                                      selectedRecs[1]?.to_designation || ""
                                    }
                                    onChange={(e) =>
                                      handleRecChange(
                                        1,
                                        "to_designation",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    {upperDesignations.data.map((d: any) => (
                                      <option
                                        key={d.designation_id}
                                        value={d.designation_id}
                                      >
                                        {d.designation}
                                      </option>
                                    ))}
                                  </select>
                                </td>

                                <td>
                                  <textarea
                                    className="form-control"
                                    disabled={!selectedRecs[1]?.selected}
                                    value={selectedRecs[1]?.justification || ""}
                                    onChange={(e) =>
                                      handleRecChange(
                                        1,
                                        "justification",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })()}

                          {/* TRANSFER (3) */}
                          {(() => {
                            const item = getRecommendationType?.data.find(
                              (x: any) => x.type_id === 3,
                            );
                            if (!item) return null;

                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedRecs[3]?.selected || false}
                                    onChange={(e) =>
                                      handleCheckboxChange(3, e.target.checked)
                                    }
                                  />
                                </td>

                                <td>{item.type_name}</td>

                                <td>
                                  <input
                                    type="text"
                                    value={profileResponse?.data[0].branch_name}
                                    className="form-control"
                                    readOnly
                                  />
                                </td>

                                <td>
                                  <select
                                    className="form-select"
                                    disabled={!selectedRecs[3]?.selected}
                                    value={selectedRecs[3]?.to_branch || ""}
                                    onChange={(e) =>
                                      handleRecChange(
                                        3,
                                        "to_branch",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    {getworkLocatation?.data.map((loc: any) => (
                                      <option
                                        key={loc.branch_id}
                                        value={loc.branch_id}
                                      >
                                        {loc.branch_name}
                                      </option>
                                    ))}
                                  </select>
                                </td>

                                <td>
                                  <textarea
                                    className="form-control"
                                    disabled={!selectedRecs[3]?.selected}
                                    value={selectedRecs[3]?.justification || ""}
                                    onChange={(e) =>
                                      handleRecChange(
                                        3,
                                        "justification",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })()}

                          {/* MARKET ADJUSTMENT (8) */}
                          {(() => {
                            const item = getRecommendationType?.data.find(
                              (x: any) => x.type_id === 8,
                            );
                            if (!item) return null;

                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedRecs[8]?.selected || false}
                                    onChange={(e) =>
                                      handleCheckboxChange(8, e.target.checked)
                                    }
                                  />
                                </td>

                                <td>{item.type_name}</td>

                                <td colSpan={2}>
                                  <div className="d-flex align-items-center gap-2">
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary"
                                      disabled={!selectedRecs[8]?.selected}
                                      onClick={decreaseMarket}
                                    >
                                      −
                                    </button>

                                    <input
                                      type="text"
                                      value={selectedRecs[8]?.adjustment || ""}
                                      disabled={!selectedRecs[8]?.selected}
                                      className="form-control text-center"
                                      style={{ width: "80px" }}
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        if (!/^\d*\.?\d*$/.test(value)) return;

                                        handleRecChange(8, "adjustment", value);
                                      }}
                                      onBlur={() => {
                                        let val = selectedRecs[8]?.adjustment;

                                        if (val === "" || val === undefined)
                                          return;

                                        let num = Number(val);

                                        if (num > 100) num = 100;
                                        if (num < 0) num = 0;

                                        handleRecChange(
                                          8,
                                          "adjustment",
                                          num.toFixed(2),
                                        );
                                      }}
                                    />

                                    <span>%</span>

                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary"
                                      disabled={!selectedRecs[8]?.selected}
                                      onClick={increaseMarket}
                                    >
                                      +
                                    </button>
                                  </div>
                                </td>

                                <td>
                                  <textarea
                                    className="form-control"
                                    disabled={!selectedRecs[8]?.selected}
                                    value={selectedRecs[8]?.justification || ""}
                                    onChange={(e) =>
                                      handleRecChange(
                                        8,
                                        "justification",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })()}

                          {/* RE-DESIGNATION (9) */}
                          {(() => {
                            const item = getRecommendationType?.data.find(
                              (x: any) => x.type_id === 9,
                            );
                            if (!item) return null;

                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedRecs[9]?.selected || false}
                                    onChange={(e) =>
                                      handleCheckboxChange(9, e.target.checked)
                                    }
                                  />
                                </td>

                                <td>{item.type_name}</td>

                                <td colSpan={2}>
                                  <select
                                    className="form-select"
                                    disabled={!selectedRecs[9]?.selected}
                                    value={
                                      selectedRecs[9]?.to_designation || ""
                                    }
                                    onChange={(e) =>
                                      handleRecChange(
                                        9,
                                        "to_designation",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    {reDesignations.data.map((d: any) => (
                                      <option
                                        key={d.designation_id}
                                        value={d.designation_id}
                                      >
                                        {d.designation}
                                      </option>
                                    ))}
                                  </select>
                                </td>

                                <td>
                                  <textarea
                                    className="form-control"
                                    disabled={!selectedRecs[9]?.selected}
                                    value={selectedRecs[9]?.justification || ""}
                                    onChange={(e) =>
                                      handleRecChange(
                                        9,
                                        "justification",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })()}

                          {/* TRAINING (10) */}
                          {(() => {
                            const item = getRecommendationType?.data.find(
                              (x: any) => x.type_id === 10,
                            );
                            if (!item) return null;

                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={
                                      selectedRecs[10]?.selected || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(10, e.target.checked)
                                    }
                                  />
                                </td>

                                <td>{item.type_name}</td>

                                <td colSpan={2}>
                                  <select
                                    className="form-select"
                                    disabled={!selectedRecs[10]?.selected}
                                    value={
                                      selectedRecs[10]?.training_type || ""
                                    }
                                    onChange={(e) =>
                                      handleRecChange(
                                        10,
                                        "training_type",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    <option value="Behavioural Training">
                                      Behavioural Training
                                    </option>
                                    <option value="Technical Training">
                                      Technical Training
                                    </option>
                                  </select>
                                </td>

                                <td>
                                  <textarea
                                    className="form-control"
                                    disabled={!selectedRecs[10]?.selected}
                                    value={
                                      selectedRecs[10]?.justification || ""
                                    }
                                    onChange={(e) =>
                                      handleRecChange(
                                        10,
                                        "justification",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })()}

                          {/* NONE OF THE ABOVE (14) */}
                          {(() => {
                            const item = getRecommendationType?.data.find(
                              (x: any) => x.type_id === 14,
                            );
                            if (!item) return null;

                            return (
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={
                                      selectedRecs[14]?.selected || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(14, e.target.checked)
                                    }
                                  />
                                </td>

                                <td>{item.type_name}</td>

                                <td colSpan={3}>
                                  <textarea
                                    className="form-control"
                                    disabled={!selectedRecs[14]?.selected}
                                    value={
                                      selectedRecs[14]?.justification || ""
                                    }
                                    placeholder="Justification"
                                    onChange={(e) =>
                                      handleRecChange(
                                        14,
                                        "justification",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })()}
                        </tbody>
                      </table>
                      {/* <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="fw-semibold mb-1">
                            Select Recommendation Type
                          </label>
                          <select
                            className="form-select"
                            name="type_id"
                            value={recommendationData?.type_id}
                            onChange={handleRecommendationChange}
                            disabled={
                              getPMSStatusManager?.data?.status === "Submit"
                            }
                          >
                            <option value="" selected disabled>
                              -- Select Recommendation --
                            </option>
                            {getRecommendationType?.data.map(
                              (item: any, index: any) => (
                                <option value={item.type_id} key={index}>
                                  {item.type_name}
                                </option>
                              ),
                            )}
                          </select>
                        </div>

                        {recommendationData?.type_id == 10 ? (
                          <>
                            <div className="col-md-6 mb-3">
                              <label className="fw-semibold mb-1">
                                Sub-recommendation
                              </label>
                              <select
                                name="training_type"
                                id=""
                                className="form-select mb-2"
                                onChange={handleRecommendationChange}
                                value={recommendationData.training_type || ""}
                                disabled={
                                  getPMSStatusManager?.data?.status === "Submit"
                                }
                              >
                                <option value="" disabled>
                                  Training Type
                                </option>
                                <option value="Behavioural Training">
                                  Behavioural Training
                                </option>
                                <option value="Technical Training">
                                  Technical Training
                                </option>
                              </select>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {recommendationData?.type_id == 9 ? (
                          <>
                            <div className="col-md-6 mb-3">
                              <label className="fw-semibold mb-1">
                                Sub-recommendation
                              </label>
                              <select
                                name="re_designation"
                                id=""
                                className="form-select mb-2"
                                onChange={handleRecommendationChange}
                                value={recommendationData.re_designation || ""}
                                disabled={
                                  getPMSStatusManager?.data?.status === "Submit"
                                }
                              >
                                <option value="" disabled>
                                  Re-designation
                                </option>
                                {reDesignations.data.map(
                                  (item: any, index: any) => (
                                    <option value={item.designation_id}>
                                      {item.designation}
                                    </option>
                                  ),
                                )}
                              </select>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {recommendationData?.type_id == 8 && (
                          <div className="col-md-6 mb-3">
                            <label className="fw-semibold mb-1">
                              Recommended Market Adjustment (Percentage)
                            </label>

                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={decreaseMarket}
                              >
                                −
                              </button>


                              <div className="d-flex align-items-center">
                                <input
                                  type="text"
                                  className="form-control text-center"
                                  value={marketAdjustment}
                                  onChange={handleMarketChange}
                                  style={{ width: "80px" }}
                                />
                                <span className="ms-1">%</span>
                              </div>

                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={increaseMarket}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        )}
                        {recommendationData.type_id == 2 ? (
                          <>
                            <div className="col-md-6">
                              <label className="fw-semibold mb-1">
                                Increment %
                              </label>
                              <input
                                type="number"
                                name="increment_percent"
                                className="form-control"
                                value={
                                  recommendationData.increment_percent || ""
                                }
                                onChange={handleRecommendationChange}
                                readOnly={
                                  getPMSStatusManager?.data?.status === "Submit"
                                }
                              />
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="row">
                        {recommendationData.type_id == 3 ? (
                          <>
                            <div className="col-md-6">
                              <input
                                type="text"
                                value={profileResponse?.data[0].branch_name}
                                className="form-control"
                                readOnly
                              />
                            </div>

                            <div className="col-md-6">
                              <select
                                name="to_location_id"
                                id=""
                                className="form-select mb-2"
                                onChange={handleRecommendationChange}
                                value={recommendationData.to_location_id || ""}
                                disabled={
                                  getPMSStatusManager?.data?.status === "Submit"
                                }
                              >
                                <option value="" selected disabled>
                                  Sub-recommendation
                                </option>
                                {getworkLocatation?.data
                                  ?.filter(
                                    (data: any) =>
                                      data.branch_id !==
                                      profileResponse?.data[0].work_location_id,
                                  )
                                  .map((item: any, index: any) => (
                                    <option value={item.branch_id}>
                                      {item.branch_name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {recommendationData?.type_id == 1 ? (
                          <>
                            <div className="col-md-6">
                              <input
                                type="text"
                                value={profileResponse?.data[0].designation}
                                className="form-control"
                                readOnly
                              />
                            </div>
                            <div className="col-md-6">
                              <select
                                name="to_designation_id"
                                id=""
                                className="form-select mb-2"
                                onChange={handleRecommendationChange}
                                value={
                                  recommendationData.to_designation_id || ""
                                }
                                disabled={
                                  getPMSStatusManager?.data?.status === "Submit"
                                }
                              >
                                <option value="" selected disabled>
                                  Recommended Designatation
                                </option>
                                {upperDesignations.data.map(
                                  (item: any, index: any) => (
                                    <option
                                      value={item.designation_id}
                                      key={index}
                                    >
                                      {item.designation}
                                    </option>
                                  ),
                                )}
                              </select>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="fw-semibold mb-1">
                          Recommendation Description / Justification
                        </label>
                        <textarea
                          className="form-control"
                          rows={5}
                          name="justification"
                          placeholder="Enter justification for the recommendation..."
                          value={recommendationData?.justification || ""}
                          onChange={handleRecommendationChange}
                          readOnly={
                            getPMSStatusManager?.data?.status === "Submit"
                          }
                        />
                      </div> */}
                    </div>
                    {(() => {
                      const endDate =
                        getappraisalTiming?.data?.r2_manager_end_date;
                      const cycleStatus =
                        getappraisalTiming?.data?.apprisal_cycle_status;
                      const today = new Date();

                      const isExpired =
                        endDate &&
                        new Date(endDate) <
                          new Date(today.toISOString().split("T")[0]);

                      const isCycleClosedOrSuspended =
                        cycleStatus === "closed" || cycleStatus === "suspended";

                      if (isExpired || isCycleClosedOrSuspended) {
                        return (
                          <div className="alert alert-danger text-center m-2">
                            The appraisal cycle is closed or the submission date
                            has expired. Please contact the HR team.
                          </div>
                        );
                      }

                      if (getPMSStatusManager?.data?.status === "Submit") {
                        return null;
                      }

                      return (
                        <div className="p-2 d-flex gap-2 justify-content-end">
                          <div>
                            <button
                              className="btn btn-primary tab-button"
                              onClick={(e: any) => {
                                ComAspSaveData(e, "Draft");
                              }}
                            >
                              Save
                            </button>
                          </div>
                          <div>
                            <button
                              className="btn btn-primary tab-button"
                              onClick={(e: any) => {
                                ComAspSaveData(e, "Submit");
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      );
                    })()}
                  </>
                ) : (
                  <div className="p-2 d-flex justify-content-center">
                    <p
                      className="text-danger fw-bold"
                      style={{ fontSize: "15px" }}
                    >
                      No records found. Please ensure that your data is
                      correctly entered, or contact support for further
                      assistance.
                    </p>
                  </div>
                )}
              </>
            )}
          </section>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Annual Review [Career Aspirations]
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              {/* Manager's Comments */}
              <div className="bg-dark p-2 text-light">
                <h6 className="text-light">R1 Manager's Comments</h6>
              </div>
              <div className="mt-2 mb-4">
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Enter manager's career aspirations comments..."
                  name="manager_carrier_aspiration"
                  value={comaspiDetailsData?.manager_carrier_aspiration}
                  readOnly
                />
              </div>

              {/* Employee's Comments */}
              <div className="bg-dark p-2 text-light">
                <h6 className="text-light">Employee's Comments</h6>
              </div>
              <div className="mt-2">
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Enter employee's career aspirations comments..."
                  readOnly
                  value={comaspiDetailsData?.employee_carrier_aspiration}
                />
              </div>

              <div className="d-flex mt-4 mb-4 gap-2 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="ratinginfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Ratings & Calculation of your score
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  This year we are using a 5 point rating scale. The value
                  assigned to each rating is as below.
                </h5>
              </div>

              {/* Dynamic Ratings Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Scale</th>
                  </tr>
                </thead>
                <tbody>
                  {ratingData && ratingData.length > 0 ? (
                    [...ratingData]
                      .reverse()
                      .map((item: any, index: number) => (
                        <tr key={index}>
                          <td>{item.rating}</td>
                          <td>{item.name}</td>
                          <td>{item.code}</td>
                          <td>{item.scale}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No rating data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Your score is determined entirely by your score on your
                  KRA/KPI OR a composite where the weight of the KRA is 80%,
                  Potential is 20%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PmsR2Manager;
